import { useEffect, useState } from 'react'

/**
 * Hook to track when the PlayCanvas iframe has loaded.
 * Returns true once the iframe's 'load' event has fired.
 */
export function useSceneLoaded(): boolean {
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        // Get the iframe element once and hold a reference for cleanup
        const iframeEl = (window as any).containerRef?.current as HTMLIFrameElement | undefined
        if (!iframeEl) return
        const onLoad = () => {
            (window as any).playCanvasReady = true;
            setLoaded(true);
        }
        iframeEl.addEventListener('load', onLoad)
        return () => {
            iframeEl.removeEventListener('load', onLoad)
        }
    }, [])

    return loaded
} 